import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCloudXmark, faSync } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HeadingItem } from 'components/heading-item/heading-item';
import { TripContext } from 'contexts';
import { head } from 'lodash';
import React, { FC, Fragment, useContext } from 'react';
import { TripStatus } from 'services/enums';
import { SyncingStatus } from 'services/enums/syncingStatus';
import { Stop, SyncStatus, Trip } from 'services/types';
import './assignment-card-header.scss';

type Props = {
    tripId: number;
};

export const AssignmentCardHeader: FC<Props> = ({ tripId}) => {
    
    const tripContext = useContext(TripContext);
    const load: Trip = tripContext.trips.find(t => t.id == tripId)?? {} as Trip;
    const stops: Stop[] = tripContext.stops.filter(s => s.tripId == load.id) ?? {} as Stop[]
    const notSyncedStops: SyncStatus[] = tripContext.syncStatus.filter(x => stops.some(s => s.id == x.id)) ?? {} as SyncStatus[]


    let headingColor: string = ''
    if(load.status == TripStatus.Complete && notSyncedStops.length > 0) {
        headingColor = '#0066A4'
    } 
    else {
        switch (load.status) {
            case TripStatus.Ready: headingColor = '#40a339'; break;
            case TripStatus.Waiting: headingColor = '#d12435'; break;
            case TripStatus.Importing: headingColor = '#d12435'; break;
            case TripStatus.Started: headingColor = '#F2994A'; break;
            case TripStatus.Complete: headingColor = '#40a339'; break;
            default: break;
        }
    }
   

    const renderTtrAndDea = () => {
        return (
            <Fragment>
                {load.isTtr &&
                    <span className={'card-badge'}>TTR</span>
                }
                {load.isDea &&
                    <span className={'card-badge'}>DEA</span>
                }
            </Fragment>
        );
    }

    const renderSyncIcon = () => {
        let icon = null
        if(notSyncedStops.length > 0) {
            if(notSyncedStops.find(x => x.status == SyncingStatus.Syncing)) {
                icon =  <FontAwesomeIcon icon={faSync as IconProp} color={'#0066A4'} size={'2x'} />
            } else {
                icon =  <FontAwesomeIcon icon={faCloudXmark as IconProp} color={'#EB5757'} size={'2x'} />
            }
        }
        return icon
    }

    let icons: React.ReactNode = renderTtrAndDea();

    return (
        <Fragment>
            <div className={'assignment-card-header-container'}>
                <div className={'assignment-card-header-left'}>
                    {icons}
                </div>
                <div className={'assignment-card-header-center'}>
                    {load.status.toString() ?
                        <div className={`assignment-card-header-item-container`} style={{ color: headingColor }}> {load.status == TripStatus.Complete && notSyncedStops.length > 0 ? 'Not Synced' : (load.status == TripStatus.Importing ? TripStatus.Waiting.toString() : load.status.toString())} </div>
                        :
                        <div>No Heading Information</div>
                    }
                </div>
                <div className={'assignment-card-header-right'}>
                    {renderSyncIcon()}
                </div>
            </div>
        </Fragment>
    )
}